export default __webpack_public_path__ + "static/media/ennovate_10.5cbe7a21.jpg";